module.exports = __webpack_public_path__ + "img/phon6.9b5212a2.png";